import { useMemo } from 'react';
import { type IUploadWidget } from '../IUploadWidget.ts';
import { UploadedFileRow } from './UploadedFileRow.tsx';

interface IUploadWidgetFileListProps {
  publicUpload: boolean | null | undefined;
  widget: IUploadWidget;
  submissionId: string | null | undefined;
  submissionModuleId: string | null | undefined;
  sectionId: string | null | undefined;
  fileId: string | null | undefined;
  filename: string | null | undefined;
  onFileChange: (value: string | null) => void;
  onFilenameChange: (value: string | null) => void;
  readonly?: boolean;
}

export function UploadWidgetFileList(props: IUploadWidgetFileListProps) {
  const {
    publicUpload,
    widget,
    submissionId,
    submissionModuleId,
    sectionId,
    fileId,
    filename,
    onFileChange,
    onFilenameChange,
    readonly,
  } = props;

  const fileList = useMemo(() => {
    return fileId && filename
      ? [
          {
            uid: fileId,
            name: filename,
            status: 'done' as const,
          },
        ]
      : [];
  }, [fileId, filename]);

  if (!fileList || fileList.length <= 0) {
    return null;
  }

  return (
    <div>
      {fileList.map(file => (
        <UploadedFileRow
          key={file.uid}
          file={file}
          isFileSigned={widget.rules?.needSign?.value ?? false}
          submissionId={submissionId}
          submissionModuleId={submissionModuleId}
          sectionId={sectionId}
          code={widget.code}
          reset={() => {
            onFileChange(null);
            onFilenameChange(null);
          }}
          omissis={!!publicUpload}
          readonly={readonly}
        />
      ))}
    </div>
  );
}
